// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"5b728c05","821":"a973b100"}[chunkId] + ".chunk.js";
};